import { getLatestAuthInfo } from 'lib/apis';
import { useMobileStore } from 'lib/store/mobileStore';
import { useUserOrderStore } from 'lib/store/userOrderStore';

export async function getIcAuthMobile() {
  const orderMobile = useUserOrderStore.getState().userOrderInfo?.orderMobile;
  const { inputMobile } = useMobileStore.getState();
  // 如果已有输入手机号或订单手机号则不再获取授权手机号
  if (inputMobile || orderMobile) {
    return;
  }
  const res = await getLatestAuthInfo();
  if (res?.code !== 0) {
    return;
  }
  return res.data?.mobile;
}
